import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
import openjpegWasmUrl from 'pdfjs-dist/wasm/openjpeg.wasm?url';
import { pdfjs } from 'react-pdf';

// Pulled straight from the installed pdfjs-dist package at build time via Vite's
// regular asset pipeline (see the pdfjs rules in vite.config.mts) rather than a CDN
// or a manually vendored copy. import.meta.url doesn't work here: this app is loaded
// into qualio-frontend as a plain injected <script> (see src/index.tsx), and in a
// non-ESM UMD build import.meta.url resolves against the *host page's* origin, not
// this script's own. These `?url` imports are instead rewritten at build time to
// URLs relative to `base`, the same resolution the webpack build got from publicPath.
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

// wasmUrl needs a directory, not a single file — derive it from one resolved asset
// URL, since all the wasm assets share the same fixed, unhashed output directory.
const wasmBaseUrl = openjpegWasmUrl.slice(
  0,
  openjpegWasmUrl.lastIndexOf('/') + 1,
);

// Without wasmUrl, pdf.js can't decode JPX/JPEG2000 images and silently drops them
// ("Dependent image isn't ready yet"), so images embedded in that format never render.
export const PDFJS_DOCUMENT_OPTIONS = {
  wasmUrl: wasmBaseUrl,
};
